import { Subject, Subscription } from "rxjs";

import {
    Component,
    DoCheck, AfterViewInit, OnDestroy,
    Input, Output, ViewChild,
    ElementRef, EventEmitter,
} from "@angular/core";

import 'leaflet';

import * as L from 'leaflet';

@Component({
    selector: 'geomap',
    templateUrl: "map.component.html",
    styleUrls: ['map.component.scss']
})
export class MapComponent implements DoCheck, AfterViewInit, OnDestroy {

    private readonly _checkSubject: Subject<null> = new Subject();

    ngDoCheck(): void {
        this._checkSubject.next(null);
    }

    ngAfterViewInit(): void {
        let map = new L.Map(this._mapContainer.nativeElement, {
            layers: [
                L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18, attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Участники OpenStreetMap</a>' })
            ],
            center: new L.LatLng(55.75583, 37.6177),
            zoom: 10,
            zoomControl: false
        });
        map.whenReady(() => {
            Promise.resolve(null).then(_ => {
                map.invalidateSize();

                // при изменении размера контейнера карты обновляем размер карты
                // приходится проверять размер контейнера периодически, т.к. отсутствуют
                // стандартные события. В leaflet неэффективно отслеживается размер контейнера
                // (см. метод L.Map.getSize()); перерасчет размер происходит только по событию изменения размера окна.
                // TODO: решить проблему обновления размера карты leaflet:
                //  - дождаться эффективной реализации изменения размера карты в leaflet.
                //  - эффективно реализовать событие изменения размера контейнера карты (например, с помощью
                //    скрытого div, привязанного к контейнеру карты, у которого будет отслеживаться существующее событие, например onScroll).
                //  - дождаться реализации события изменения размера элемента DOM (необходимо учесть, что в старых браузерах его не будет).

                this.stopMapContainerSizeWatcher();
                this._mapContainerSizeChangeSubjectSubscription = this._checkSubject
                    .auditTime(250)
                    .map<null, { w: number, h: number }>(value => { return { w: +this._mapContainer.nativeElement.clientWidth, h: +this._mapContainer.nativeElement.clientHeight }; })
                    .distinctUntilChanged((a, b) => a.w == b.w && a.h == b.h)
                    .subscribe(size => {
                        map.invalidateSize(true);
                    });
                
                this.setMap(map);
            });
        });
    }

    ngOnDestroy(): void {
        this.setMap(null);
        this.stopMapContainerSizeWatcher();
    }

    @ViewChild("mapPlaceholder")
    private _mapContainer: ElementRef;
    private _mapContainerSizeChangeSubjectSubscription: Subscription;

    private stopMapContainerSizeWatcher() {
        if (this._mapContainerSizeChangeSubjectSubscription) {
            this._mapContainerSizeChangeSubjectSubscription.unsubscribe();
            this._mapContainerSizeChangeSubjectSubscription = null;
        }
    }

    private _map: L.Map;

    public get map(): L.Map {
        return this._map;
    }
    private setMap(map: L.Map) {
        this._map = map;
        this.mapChange.emit(this._map);
    }
    @Output()
    public readonly mapChange: EventEmitter<L.Map> = new EventEmitter();

    @Input()
    public width: string = "100%";

    @Input()
    public height: string = "100%";
}



// WEBPACK FOOTER //
// /app/SPA/src/app/core/maps/map.component.ts